import React, { useState } from 'react';
import styled from 'styled-components';
import { NextIcon, SellIcon } from '@kvdbil/components';
import { UnmountClosed } from 'react-collapse';
import Header from './Header';
import { ServiceContainer } from '..';
import Link from '../../../../../../../shared/components/Link';
import { CMSDataObjectPageService } from '~/App/views/ObjectPage/cmsDataHandlers';
import StructuredText from '~/App/components/DatoCMS/StructuredText';

const CollapseWrapper = styled.div`
  padding: 0 1rem;
`;

const StructuredTextWrapper = styled.div`
  & {
    margin: 1rem 0;
  }

  & ul {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  & li {
    display: flex;
    align-items: center;

    &:before {
      width: 1.5rem;
      height: 1.5rem;
      background-image: url('/images/icons/CheckIconGreen.svg'); // Same as theme
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
      content: '';
      margin-right: 0.5em;
    }
  }
`;

const ReadMore = styled(Link)`
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-weight: ${({ theme }) => theme.typography.fontBaseBoldWeight};
`;

interface Props {
  cmsData: CMSDataObjectPageService;
}

const GeneralService = ({ cmsData }: Props) => {
  const [isExpanded, setExpanded] = useState(false);

  const toggleExpanded = () => {
    setExpanded(isExpanded => !isExpanded);
  };
  const ariaControls = 'additional-service-sell-object-content';

  return (
    <ServiceContainer data-testid="generalService">
      <Header
        isExpanded={isExpanded}
        toggleExpanded={toggleExpanded}
        icon={cmsData?.icon ?? SellIcon}
        responsiveImage={cmsData?.image?.responsiveImage}
        title={cmsData?.title ?? ''}
        description={cmsData?.description ?? ''}
        ariaControls={ariaControls}
      />

      <UnmountClosed
        key="generalService"
        isOpened={isExpanded}
        initialStyle={{ overflow: 'initial', height: 'auto' }}
      >
        <CollapseWrapper id={ariaControls}>
          <StructuredText
            data={cmsData?.content}
            wrapper={StructuredTextWrapper}
          />
        </CollapseWrapper>
        <ReadMore
          to={cmsData?.link?.[0]?.url ?? ''}
          target="_blank"
          rel="noopener noreferrer"
        >
          {cmsData?.link?.[0]?.text} <NextIcon />
        </ReadMore>
      </UnmountClosed>
    </ServiceContainer>
  );
};

export default GeneralService;
